import { render, staticRenderFns } from "./RichMap.vue?vue&type=template&id=087bb998&"
import script from "./RichMap.vue?vue&type=script&lang=js&"
export * from "./RichMap.vue?vue&type=script&lang=js&"
import style0 from "./RichMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports